import { useCallback, useMemo } from 'react';
import { isEmpty } from 'lodash';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { TAB_QUERY_PARAM } from 'pages/ValuationsAllocation/common/constants/valuations';
import { setQueryString } from 'utilities';

const useTabQueryParam = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;

  const parsedQuery = useMemo(() => queryString.parse(search), [search]);
  const { [TAB_QUERY_PARAM]: tabId } = parsedQuery;

  const setApproachQueryParam = useCallback(
    (id: string) => {
      if (!isEmpty(id) && tabId !== id) {
        setQueryString({
          navigate,
          paramName: TAB_QUERY_PARAM,
          paramValue: id,
          pathname,
          searchParams: queryString.stringify(parsedQuery),
          shouldPushPath: true,
        });
      }
    },
    [tabId, navigate, parsedQuery, pathname]
  );

  return {
    tabId,
    setApproachQueryParam,
  };
};

export default useTabQueryParam;
